import { useState } from "react";
import { CiMail } from "react-icons/ci";
import { BiLock } from "react-icons/bi";
import { Link } from "react-router-dom";
// import { BsArrowLeftCircle } from 'react-icons/bs'
import { TiTickOutline } from "react-icons/ti";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPatientForm, setShowPatientForm] = useState(false);
  const [showDoctorForm, setShowDoctorForm] = useState(false);

  // submit login form
  const handleLoginForm = (e) => {
    // prevent default form behaviour
    e.preventDefault();
    console.log("user logged in");
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <h3>Choose Account Type</h3>
        <div className="type">
          <p
            onClick={() => {
              setShowDoctorForm(!showDoctorForm);
              setShowPatientForm(false);
            }}
          >
            {showDoctorForm && showPatientForm === false && (
              <i
                style={{
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  height: "30px",
                  width: "30px",
                  border: "none",
                  borderRadius: "50%",
                  background: "#03fc17",
                }}
              >
                <TiTickOutline />
              </i>
            )}
            Doctor
          </p>
          <p
            onClick={() => {
              setShowPatientForm(!showPatientForm);
              setShowDoctorForm(false);
            }}
          >
            {showPatientForm && showDoctorForm === false && (
              <i
                style={{
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  height: "30px",
                  width: "30px",
                  border: "none",
                  borderRadius: "50%",
                  background: "#03fc17",
                }}
              >
                <TiTickOutline />
              </i>
            )}
            Patient
          </p>
        </div>
        <form onSubmit={handleLoginForm}>
          <div className="input">
            <i>
              <CiMail size={30} fill={"#b6b6b6"} />
            </i>
            <input
              type="email"
              value={email}
              className={email === "" ? "error" : "input-field"}
              placeholder="Enter email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input">
            <i>
              <BiLock size={30} fill={"#b6b6b6"} />
            </i>
            <input
              type="password"
              placeholder="Password"
              value={password}
              className={password === "" ? "error" : "input-field"}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" id="login-button">
            Login
          </button>
          <p id="reg-text">
            New to OkoaPatient? <Link to="/register">Create Account</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
